import { RemoteAuthenticationLogin } from 'data/usecases';
import { AuthenticationLoginUseCaseInterface } from 'domain/usecases/authentication/authentication-login';
import { makeApiUrlAuthenticationLogin } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthenticationLogin =
  (): AuthenticationLoginUseCaseInterface => {
    return new RemoteAuthenticationLogin(
      makeApiUrlAuthenticationLogin(),
      makeAxiosHttpClient(),
    );
  };
